import React, { useEffect, useState } from "react";
import { CarPlateCard } from "../../components";
import cardData from "../../data/ProductData.json";
import { useNavigate } from "react-router-dom";
import { Dashboard } from "../../types/General";
import useTranslation from "../../hooks/Translation";
import { getFromStorage, STORAGE_KEYS } from "../../helpers";

type props = {
  dashboardData: Dashboard | null;
  loading: boolean;
};

const LatestAds = ({ dashboardData, loading }: props) => {
  const language = getFromStorage(STORAGE_KEYS.language);

  const translation = useTranslation();
  const navigate = useNavigate();
  const [favItems, setFavItems] = useState<any[]>([]);
  const [likeItems, setLikeItems] = useState<any[]>([]);

  const checkFav = () => {
    const binaryData = dashboardData?.latestAds || [];
    const fav_data = binaryData
      .filter((item: any) => item?.isWishlistByMe)
      .map((item: any) => item);
    const like_data = binaryData
      .filter((item: any) => item?.isLikedByMe)
      .map((item: any) => item);
    setLikeItems(like_data);
    setFavItems(fav_data);
  };

  useEffect(() => {
    checkFav();
  }, [dashboardData?.latestAds]);

  return (
    <section className="prodcts_sc container ">
      <div className="prdct_hdngs pt">
        <h2>{translation?.home.latesPost}</h2>
        {dashboardData?.latestAds?.length &&
        dashboardData?.latestAds?.length > 5 ? (
          <p
            onClick={() =>
              navigate("/see-all", {
                state: {
                  key: translation.home.latesPost,
                  type: "latest",
                },
              })
            }
            // onClick={() => navigate("/filter", { state: "showOption" })}
          >
            {translation?.home.seeAll}
          </p>
        ) : null}
      </div>
      <div className="crds_sec">
        {!dashboardData?.latestAds?.length && !loading ? (
          <div className="noData">
            <figure>
              <img src="/static/images/noData.webp" alt="" />
            </figure>
            <h3> {translation?.error.noData}</h3>
          </div>
        ) : dashboardData?.latestAds?.length ? (
          dashboardData?.latestAds
            ?.slice(0, 5)
            .map((item) => (
              <CarPlateCard
                category={
                  language === "en"
                    ? item?.categoryData?.categoryName || ""
                    : item?.categoryData?.categoryName_ar || ""
                }
                posttitle={item?.posttitle}
                price={item?.price}
                carPlatenumber={item?.carPlatenumber}
                _id={item?._id}
                setFavItems={setFavItems}
                favItems={favItems}
                item={item}
                likeItems={likeItems}
                setLikeItems={setLikeItems}
              />
            ))
        ) : null}
      </div>
    </section>
  );
};

export default LatestAds;
